import { useState, useCallback } from 'react';
import toast from 'react-hot-toast';
import { makeupcreditService } from '../services/makeupCredit';

export const useReportAbsence = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const reportAbsence = useCallback(
    async (
      bookingId: string,
      reason?: string,
      options?: { lessonDate?: string; studentId?: string; sessionId?: string }
    ) => {
      setIsLoading(true);
      setError(null);

      try {
        await makeupcreditService.reportAbsence(bookingId, reason, options);
        toast.success('Absence reported! You earned 1 make-up credit.');
      } catch (err) {
        const axiosData =
          err && typeof err === 'object' && 'response' in err
            ? (err as { response?: { data?: { error?: string } } }).response?.data
            : undefined;
        const errorMessage =
          axiosData?.error ||
          (err instanceof Error ? err.message : 'Failed to report absence');
        setError(errorMessage);
        toast.error(errorMessage);
        throw err;
      } finally {
        setIsLoading(false);
      }
    },
    []
  );

  return {
    isLoading,
    error,
    reportAbsence,
  };
};

export default useReportAbsence;
